// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pTEjL","newExpiryDate":"styles_newExpiryDate__CK9Ps","footer":"styles_footer__2oRFu"};